/* ANCORA — interacciones ligeras (aparición suave, carrusel de reseñas y
   controles de las tarjetas de producto). Sin librerías.
   Respeta prefers-reduced-motion. */
(function () {
  'use strict';

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var targets = (root || document).querySelectorAll('.anc-reveal:not(.is-in)');
    if (!targets.length) return;

    if (reduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var delay = parseInt(el.getAttribute('data-anc-delay') || '0', 10);
          window.setTimeout(function () {
            el.classList.add('is-in');
          }, delay);
          io.unobserve(el);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    targets.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Carrusel de reseñas destacadas
     ------------------------------------------------------------------ */
  function testimonials(root) {
    var carousels = (root || document).querySelectorAll('[data-anc-tst]:not([data-anc-ready])');

    carousels.forEach(function (carousel) {
      carousel.setAttribute('data-anc-ready', 'true');

      var viewport = carousel.querySelector('.anc-tst__viewport');
      var track = carousel.querySelector('[data-anc-tst-track]');
      var prev = carousel.querySelector('[data-anc-tst-prev]');
      var next = carousel.querySelector('[data-anc-tst-next]');
      if (!viewport || !track) return;

      function step() {
        var item = track.querySelector('.anc-tst__item');
        if (!item) return viewport.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).columnGap || '12') || 12;
        return item.getBoundingClientRect().width + gap;
      }

      function sync() {
        var scrollable = viewport.scrollWidth - viewport.clientWidth > 4;
        var atStart = viewport.scrollLeft <= 4;
        var atEnd = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 4;

        if (prev) {
          prev.hidden = !scrollable;
          prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
          prev.style.opacity = atStart ? '0.35' : '1';
        }
        if (next) {
          next.hidden = !scrollable;
          next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
          next.style.opacity = atEnd ? '0.35' : '1';
        }
      }

      function go(direction) {
        var max = viewport.scrollWidth - viewport.clientWidth;
        var from = viewport.scrollLeft;
        var target = Math.max(0, Math.min(max, from + direction * step()));

        viewport.scrollTo({ left: target, behavior: reduced ? 'auto' : 'smooth' });

        // Red de seguridad: si el navegador no anima el desplazamiento, lo movemos a mano.
        window.setTimeout(function () {
          if (Math.abs(viewport.scrollLeft - from) < 2) viewport.scrollLeft = target;
          sync();
        }, 450);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          go(-1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          go(1);
        });
      }

      viewport.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      // «Ver más» solo cuando el texto realmente se corta
      carousel.querySelectorAll('[data-anc-tst-text]').forEach(function (text) {
        var body = text.parentElement;
        var more = body && body.querySelector('[data-anc-tst-more]');
        if (!more) return;

        if (text.scrollHeight - text.clientHeight > 2) {
          more.hidden = false;
          var openLabel = more.textContent.trim();
          var closeLabel = 'Ver menos';

          more.addEventListener('click', function () {
            var open = text.classList.toggle('is-open');
            more.textContent = open ? closeLabel : openLabel;
            sync();
          });
        }
      });
    });
  }

  /* ------------------------------------------------------------------
     Comparador de fotos «antes / después»
     ------------------------------------------------------------------ */
  function compare(root) {
    var nodes = (root || document).querySelectorAll('[data-anc-compare]:not([data-anc-ready])');

    nodes.forEach(function (node) {
      node.setAttribute('data-anc-ready', 'true');
      var range = node.querySelector('[data-anc-compare-range]');
      if (!range) return;

      function paint() {
        node.style.setProperty('--anc-cmp-pos', range.value + '%');
      }

      range.addEventListener('input', paint);
      range.addEventListener('change', paint);
      paint();
    });
  }

  /* ------------------------------------------------------------------
     Tarjetas de producto: las flechas y los puntos del carrusel de fotos
     viven dentro del enlace del producto. Sin esto, tocarlos abriría la
     ficha en vez de pasar a la siguiente foto.
     ------------------------------------------------------------------ */
  function guardCardControls() {
    if (document.documentElement.hasAttribute('data-anc-card-guard')) return;
    document.documentElement.setAttribute('data-anc-card-guard', 'true');

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var control = target.closest('slideshow-arrows, slideshow-controls');
        if (!control || !control.closest('.card-gallery')) return;
        event.preventDefault();
      },
      true
    );
  }

  function init(root) {
    reveal(root);
    testimonials(root);
    compare(root);
    guardCardControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // El editor de temas vuelve a pintar secciones: re-inicializar.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
